var _g, _g2, _g3, _path, _g4, _path2, _path3, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 251,
    viewBox: "0 0 249 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1386 111.833L81.8564 107.381L69.3336 114C65.9048 115.812 61.8875 112.903 62.5397 109.08L64.7976 95.8468L51.5429 94.1471C47.7064 93.6552 46.0923 88.9832 48.8071 86.228L58.8137 76.0731L48.6319 66.0949C45.8697 63.388 47.4017 58.6887 51.2288 58.1296L64.453 56.1973L61.9662 43.0044C61.2478 39.1938 65.2133 36.2151 68.6724 37.967L81.3092 44.3656L87.5684 31.6153C89.28 28.1282 94.2507 28.1282 95.9624 31.6153L101.854 43.6163L113.53 37.1809C116.926 35.3084 120.994 38.1478 120.408 41.9813L118.255 56.0774L132.302 58.1296C136.129 58.6887 137.661 63.388 134.898 66.0949L125.312 75.4896L127.892 77.9311C125.149 80.8745 122.662 83.7895 120.527 86.588L109.791 85.7481C107.689 85.5838 105.635 86.4391 104.276 88.0457L84.1386 111.833Z",
    fill: "url(#paint0_linear_685_1574)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.93 100.982C180.506 109.199 176.588 116.895 172.628 123.001L177.168 132.909C178.043 134.819 177.939 137.033 176.889 138.855L160.215 167.785C161.223 168.004 162.325 167.89 163.372 167.337L180.325 158.377L197.277 167.337C200.706 169.149 204.723 166.24 204.071 162.417L200.827 143.401L214.592 129.911C217.354 127.203 215.822 122.504 211.995 121.945L192.995 119.169L184.522 101.907C184.354 101.565 184.155 101.257 183.93 100.982Z",
    fill: "url(#paint1_linear_685_1574)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.628 123.001C188.02 99.2657 202.791 51.4891 190.323 42.5917C177.668 33.9931 137.702 64.0776 120.527 86.588L109.791 85.7481C107.689 85.5838 105.635 86.4392 104.276 88.0458L75.2862 122.289C74.3248 123.426 75.2653 125.144 76.7439 124.952L96.5978 122.378C95.3486 124.998 94.7452 126.981 94.7895 128.379C94.8453 130.122 96.5709 132.806 99.0368 135.734C95.7101 140.024 94.0482 146.677 93.975 148.729C93.8625 151.887 100.015 158.719 106.143 162.865C112.272 167.012 120.709 170.593 123.651 169.406C125.584 168.626 131.406 164.711 134.282 160.059C137.619 161.214 140.477 161.797 142.043 161.285C143.373 160.85 145.032 159.613 147.067 157.562L151.49 177.247C151.815 178.696 153.759 178.987 154.501 177.699L176.889 138.855C177.939 137.033 178.043 134.819 177.168 132.909L172.628 123.001Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_685_1574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 41,
    width: 121,
    height: 138
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.628 123.001C188.02 99.2657 202.791 51.4891 190.323 42.5917C177.668 33.9931 137.702 64.0776 120.527 86.588L109.791 85.7481C107.689 85.5838 105.635 86.4392 104.276 88.0458L75.2862 122.289C74.3248 123.426 75.2653 125.144 76.7439 124.952L96.5978 122.378C95.3486 124.998 94.7452 126.981 94.7895 128.379C94.8453 130.122 96.5709 132.806 99.0368 135.734C95.7101 140.024 94.0482 146.677 93.975 148.729C93.8625 151.887 100.015 158.719 106.143 162.865C112.272 167.012 120.709 170.593 123.651 169.406C125.584 168.626 131.406 164.711 134.282 160.059C137.619 161.214 140.477 161.797 142.043 161.285C143.373 160.85 145.032 159.613 147.067 157.562L151.49 177.247C151.815 178.696 153.759 178.987 154.501 177.699L176.889 138.855C177.939 137.033 178.043 134.819 177.168 132.909L172.628 123.001Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_685_1574)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7403 127.946L98.0808 108.557L116.924 118.469C120.354 120.273 124.364 117.361 123.709 113.541L121.058 98.0742L142.488 94.0206C146.226 93.3136 147.599 88.6755 144.849 86.0468L128.974 70.8744C126.347 73.8203 123.93 76.7278 121.779 79.5472L106.119 78.3224C104.018 78.1581 101.964 79.0135 100.604 80.6201L65.5503 122.028L69.6532 130.42L88.7403 127.946Z",
    fill: "#2313FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.868 78.2687C195.984 92.3832 189.252 105.604 182.449 116.094L191.258 135.319C192.133 137.228 192.029 139.442 190.979 141.264L158.937 196.86C155.809 197.635 152.65 194.944 153.234 191.522L160.01 151.802L131.283 123.651C128.521 120.943 130.053 116.244 133.88 115.685L173.556 109.889L191.276 73.79C192.987 70.3034 197.958 70.3034 199.67 73.79L201.868 78.2687Z",
    fill: "#FFB334"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.396583,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.408 14.2209L262.861 51.8506L147.903 216.912L94.4504 179.282L209.408 14.2209Z",
    fill: "#00081B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.600153,
    filter: "url(#filter5_f_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.696 42.5833C184.184 42.5833 157.73 47.9881 146.077 64.2837C134.425 80.5793 127.535 88.4127 111.666 88.4127C95.7971 88.4127 76.6169 122.595 76.6169 122.595C76.6169 122.595 98.5822 122.987 98.5822 129.674C98.5822 136.362 97.5914 152.448 97.5914 154.706",
    stroke: "white",
    strokeWidth: 18.7819,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.527 86.588L109.791 85.7481C107.689 85.5839 105.635 86.4392 104.276 88.0458L75.2862 122.289C74.3248 123.426 75.2653 125.144 76.7439 124.952L96.5978 122.378C99.8558 115.545 107.502 104.384 119.479 87.9915C119.818 87.527 120.167 87.059 120.527 86.588Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.067 157.562L151.49 177.247C151.815 178.696 153.759 178.987 154.501 177.699L176.889 138.855C177.939 137.033 178.043 134.819 177.168 132.909L172.628 123.001C172.325 123.467 172.023 123.924 171.72 124.371C160.328 141.206 152.402 152.185 147.067 157.562Z",
    fill: "black",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_685_1574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 58,
    width: 176,
    height: 175
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.702 58.7614H10V232.082H185.702V58.7614Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.309 164.36C135.702 140.625 150.473 92.8482 138.004 83.9509C125.349 75.3522 85.3842 105.437 68.2088 127.947L57.4724 127.107C55.3709 126.943 53.3172 127.798 51.9575 129.405L22.9679 163.649C22.0065 164.785 22.947 166.503 24.4256 166.311L44.2795 163.737C43.0303 166.357 42.4269 168.34 42.4712 169.738C42.527 171.481 44.2526 174.165 46.7185 177.093C43.3918 181.383 41.7299 188.036 41.6567 190.088C41.5442 193.246 47.6963 200.078 53.825 204.225C59.9537 208.371 68.3911 211.952 71.3329 210.765C73.2662 209.985 79.0882 206.071 81.9638 201.418C85.301 202.573 88.1588 203.157 89.7245 202.644C91.0548 202.209 92.7132 200.972 94.7485 198.921L99.1715 218.606C99.4971 220.055 101.441 220.346 102.183 219.058L124.571 180.214C125.621 178.392 125.725 176.178 124.849 174.268L120.309 164.36Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.628 123.001C188.02 99.2657 202.791 51.4891 190.323 42.5917C177.668 33.9931 137.702 64.0776 120.527 86.588L109.791 85.7481C107.689 85.5838 105.635 86.4392 104.276 88.0458L75.2862 122.289C74.3248 123.426 75.2653 125.144 76.7439 124.952L96.5978 122.378C95.3486 124.998 94.7452 126.981 94.7895 128.379C94.8453 130.122 96.5709 132.806 99.0368 135.734C95.7101 140.024 94.0482 146.677 93.975 148.729C93.8625 151.887 100.015 158.719 106.143 162.865C112.272 167.012 120.709 170.593 123.651 169.406C125.584 168.626 131.406 164.711 134.282 160.059C137.619 161.214 140.477 161.797 142.043 161.285C143.373 160.85 145.032 159.613 147.067 157.562L151.49 177.247C151.815 178.696 153.759 178.987 154.501 177.699L176.889 138.855C177.939 137.033 178.043 134.819 177.168 132.909L172.628 123.001Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.323 42.5917L191.082 41.6965L191.071 41.6886L191.06 41.6811L190.323 42.5917ZM172.628 123.001L171.591 122.445L171.269 122.942L171.507 123.463L172.628 123.001ZM120.527 86.588L120.39 87.7057L121.097 87.7609L121.513 87.2163L120.527 86.588ZM109.791 85.7481L109.928 84.6304L109.791 85.7481ZM104.276 88.0457L103.327 87.3706L104.276 88.0457ZM75.2861 122.289L74.3377 121.614L75.2861 122.289ZM76.7439 124.952L76.609 123.841L76.7439 124.952ZM96.5977 122.378L97.707 122.805L98.5703 120.994L96.4633 121.267L96.5977 122.378ZM94.7895 128.379L93.5762 128.444L94.7895 128.379ZM99.0368 135.734L100.017 136.369L100.551 135.68L100.003 135.029L99.0368 135.734ZM93.975 148.728L92.7617 148.723L93.975 148.728ZM123.651 169.406L124.11 170.432L123.651 169.406ZM134.282 160.059L134.737 159.007L133.76 158.669L133.232 159.524L134.282 160.059ZM142.043 161.285L142.419 162.341L142.043 161.285ZM147.067 157.562L148.256 157.304L147.784 155.204L146.183 156.817L147.067 157.562ZM151.49 177.247L152.679 176.989L151.49 177.247ZM154.501 177.699L153.433 177.194L154.501 177.699ZM176.889 138.855L175.82 138.35L176.889 138.855ZM177.168 132.909L176.047 133.371L177.168 132.909ZM189.563 43.4863C192.223 45.3842 193.642 49.5663 193.769 55.6253C193.894 61.5962 192.758 69.0422 190.741 77.0066C186.707 92.9357 179.209 110.698 171.591 122.445L173.665 123.557C181.439 111.569 189.023 93.575 193.105 77.4576C195.146 69.3987 196.327 61.7485 196.197 55.5172C196.068 49.3741 194.657 44.2476 191.082 41.6965L189.563 43.4863ZM121.513 87.2163C130.011 76.0786 144.194 63.0181 157.818 53.823C164.631 49.2242 171.242 45.6356 176.882 43.7248C182.601 41.7876 186.935 41.701 189.585 43.5018L191.06 41.6811C187.383 39.1828 181.975 39.6324 176.105 41.6213C170.155 43.6367 163.329 47.3637 156.422 52.0247C142.606 61.3502 128.218 74.5869 119.541 85.9592L121.513 87.2163ZM120.664 85.4703L109.928 84.6304L109.654 86.8658L120.39 87.7057L120.664 85.4703ZM109.928 84.6304C107.397 84.4322 104.939 85.4673 103.327 87.3706L105.224 88.7208C106.332 87.4109 107.981 86.7348 109.654 86.8658L109.928 84.6304ZM103.327 87.3706L74.3377 121.614L76.2346 122.964L105.224 88.7208L103.327 87.3706ZM74.3377 121.614C73.5192 122.582 73.5347 123.773 74.0131 124.648C74.493 125.523 75.5351 126.237 76.8783 126.063L76.609 123.841C76.4741 123.859 76.3068 123.809 76.1868 123.59C76.0658 123.368 76.0917 123.133 76.2346 122.964L74.3377 121.614ZM76.8783 126.063L96.7327 123.489L96.4633 121.267L76.609 123.841L76.8783 126.063ZM96.0033 128.314C95.9669 127.184 96.4693 125.401 97.707 122.805L95.489 121.95C94.2284 124.594 93.5229 126.778 93.5762 128.444L96.0033 128.314ZM100.003 135.029C98.7903 133.589 97.7832 132.237 97.0772 131.05C96.3528 129.832 96.0227 128.914 96.0033 128.314L93.5762 128.444C93.6125 129.587 94.1731 130.882 94.9413 132.174C95.7285 133.497 96.8168 134.95 98.0704 136.438L100.003 135.029ZM95.1888 148.733C95.2201 147.855 95.6179 145.791 96.4424 143.38C97.2629 140.984 98.4612 138.375 100.017 136.369L98.0565 135.098C96.2856 137.382 94.9896 140.245 94.1288 142.761C93.273 145.262 92.8035 147.551 92.7617 148.723L95.1888 148.733ZM106.879 161.954C103.899 159.938 100.901 157.258 98.6718 154.707C97.5576 153.431 96.655 152.211 96.0441 151.141C95.4133 150.037 95.1709 149.226 95.1888 148.733L92.7617 148.723C92.7229 149.81 93.2068 151.038 93.8894 152.232C94.5918 153.462 95.5896 154.8 96.765 156.146C99.1159 158.837 102.259 161.647 105.408 163.777L106.879 161.954ZM123.192 168.38C122.815 168.533 122.045 168.59 120.801 168.367C119.609 168.153 118.17 167.716 116.591 167.101C113.439 165.871 109.877 163.982 106.879 161.954L105.408 163.777C108.539 165.895 112.259 167.87 115.593 169.171C117.259 169.821 118.863 170.316 120.272 170.569C121.629 170.813 123.017 170.873 124.11 170.432L123.192 168.38ZM133.232 159.524C131.889 161.695 129.827 163.739 127.83 165.349C125.814 166.973 123.989 168.059 123.192 168.38L124.11 170.432C125.247 169.973 127.299 168.711 129.397 167.021C131.512 165.315 133.799 163.074 135.332 160.594L133.232 159.524ZM141.667 160.229C141.198 160.382 140.354 160.411 139.08 160.194C137.847 159.984 136.371 159.572 134.737 159.007L133.828 161.111C135.531 161.7 137.151 162.158 138.573 162.4C139.954 162.636 141.321 162.7 142.419 162.341L141.667 160.229ZM146.183 156.817C144.16 158.856 142.682 159.897 141.667 160.229L142.419 162.341C144.065 161.802 145.903 160.371 147.951 158.307L146.183 156.817ZM145.877 157.82L150.3 177.505L152.679 176.989L148.256 157.304L145.877 157.82ZM150.3 177.505C150.563 178.674 151.513 179.442 152.611 179.607C153.724 179.773 154.934 179.306 155.57 178.204L153.433 177.194C153.368 177.307 153.301 177.35 153.257 177.37C153.207 177.392 153.143 177.403 153.067 177.392C152.927 177.371 152.741 177.269 152.679 176.989L150.3 177.505ZM155.57 178.204L177.957 139.36L175.82 138.35L153.433 177.194L155.57 178.204ZM177.957 139.36C179.187 137.225 179.3 134.656 178.288 132.447L176.047 133.371C176.785 134.982 176.691 136.84 175.82 138.35L177.957 139.36ZM178.288 132.447L173.748 122.539L171.507 123.463L176.047 133.371L178.288 132.447Z",
    fill: "url(#paint2_linear_685_1574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.348 93.73C159.515 97.3474 166.631 96.0976 170.244 90.9384C173.856 85.7793 172.597 78.6644 167.43 75.047C162.264 71.4296 155.148 72.6794 151.535 77.8385C147.923 82.9977 149.182 90.1125 154.348 93.73Z",
    fill: "url(#paint3_linear_685_1574)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.753 141.562C116.063 138.978 115.166 133.892 117.749 130.201L133.927 107.097C136.511 103.407 141.597 102.511 145.287 105.095C148.978 107.678 149.874 112.765 147.29 116.455L131.113 139.558C128.529 143.248 123.443 144.145 119.753 141.562Z",
    fill: "url(#paint4_linear_685_1574)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_685_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1471 177.253C58.894 180.535 58.3319 183.993 58.4812 187.524L58.6052 190.417C58.6311 190.837 59.0692 191.102 59.4456 190.92L62.04 189.66C63.6645 188.867 65.6654 188.4 67.9656 188.276C68.1149 188.27 68.218 188.333 68.2802 188.385C68.3419 188.437 68.4191 188.535 68.4246 188.686C68.4346 188.82 68.3778 188.95 68.2802 189.038C64.9843 191.967 62.4109 196.421 60.632 202.296C59.1464 207.17 59.0125 212.002 60.2088 216.669L61.0856 220.07C61.1991 220.516 61.7716 220.656 62.0813 220.314L64.4432 217.711C66.0572 215.933 67.749 214.626 69.4557 213.843C71.5447 212.884 73.7727 212.282 76.0827 212.054C77.7023 211.899 79.3218 211.919 80.91 212.127C84.7471 212.635 88.7076 212.251 92.349 211.027C96.0257 209.788 99.4192 207.673 102.173 204.904C104.607 202.457 106.485 199.605 107.758 196.416C108.981 193.342 109.599 190.085 109.584 186.751C109.564 183.412 108.924 180.156 107.666 177.076C106.366 173.882 104.468 171.02 102.019 168.557C99.569 166.094 96.7222 164.186 93.5503 162.874C90.487 161.609 87.2484 160.956 83.9271 160.946C80.6058 160.925 77.3672 161.547 74.3138 162.781C71.1424 164.062 68.3056 165.949 65.8715 168.397C63.3548 170.927 61.4261 173.903 60.1471 177.253Z",
    fill: "url(#paint5_radial_685_1574)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_685_1574",
    x: 0.269248,
    y: 0.827149,
    width: 164.21,
    height: 160.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.39095,
    dy: 9.39095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7819
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.573674 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_685_1574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_685_1574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_685_1574",
    x: 107,
    y: 75.9394,
    width: 124.651,
    height: 135.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -18.7819,
    dy: 9.39095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.165981 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_685_1574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_685_1574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_685_1574",
    x: 34.2018,
    y: 19.1751,
    width: 214.006,
    height: 231.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.26063,
    dy: 25.0425
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4774
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65281 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_685_1574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_685_1574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_685_1574",
    x: 27.2595,
    y: 32.5836,
    width: 157.329,
    height: 136.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1454,
    result: "effect1_foregroundBlur_685_1574"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_685_1574",
    x: 91.5846,
    y: 32.8843,
    width: 148.574,
    height: 202.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1454,
    result: "effect1_foregroundBlur_685_1574"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_685_1574",
    x: -3.08089,
    y: -30.6259,
    width: 261.986,
    height: 258.541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.9091,
    result: "effect1_foregroundBlur_685_1574"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_685_1574",
    x: 11.503,
    y: 132.772,
    width: 126.254,
    height: 134.687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.39095,
    dy: 9.39095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7819
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.0945956 0 0 0 0 0.719394 0 0 0 0.630555 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_685_1574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_685_1574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_685_1574",
    x1: 22.6409,
    y1: 54.5569,
    x2: 73.096,
    y2: 126.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A760FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3430FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_685_1574",
    x1: 160.215,
    y1: 100.982,
    x2: 160.215,
    y2: 167.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_685_1574",
    x1: 108.369,
    y1: 37.3556,
    x2: 101.651,
    y2: 164.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDF3",
    stopOpacity: 0.282797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382543,
    stopColor: "#FEA6A6",
    stopOpacity: 0.776647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755261,
    stopColor: "#FFCC8F",
    stopOpacity: 0.536274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF80AE",
    stopOpacity: 0.203274
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_685_1574",
    x1: 161.95,
    y1: 89.3001,
    x2: 166.524,
    y2: 94.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_685_1574",
    x1: 137.782,
    y1: 110.33,
    x2: 117.176,
    y2: 139.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565D72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_685_1574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0217 217.121) rotate(-52.0101) scale(57.1076 45.334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D800B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImg);
export default __webpack_public_path__ + "static/media/dashboard-img.9f6a57a93d03c0629aba6e21c4351788.svg";
export { ForwardRef as ReactComponent };